"use strict";
exports.__esModule = true;
exports.useParseQuery = void 0;
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./useParseQuery"), exports);
var useParseQuery_1 = require("./useParseQuery");
(0, tslib_1.__createBinding)(exports, useParseQuery_1, "default", "useParseQuery");
//# sourceMappingURL=index.js.map